import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthHttp, AUTH_HTTP_PROVIDER } from './auth/authentication.http';

import { AppRoutingModule } from './app-routing.module';
import { AvemovBaseModule } from './base/base.module';

import { AppState, InternalStateType } from './app.service';
import { GlobalState } from './global.state';

import { UbiModule } from './theme/ubi.module';
import { UbiLoginComponent } from './theme/components';
import { DynamicFormModule } from './dynamic-form/dynamic-form.module';
import { DynamicEntityModule } from './dynamic-entity/dynamic-entity.module';

import { AppComponent } from './app.component';

import { AuthenticationService } from './auth/index';

import { AuthGuard } from './ubi-core/auth-guard.service';

// Application wide providers
const APP_PROVIDERS = [
  AppState,
  GlobalState,
  AuthGuard,
  AuthenticationService
];

@NgModule({
  declarations: [
    AppComponent,
    UbiLoginComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    NgbModule.forRoot(),
    UbiModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    AppRoutingModule,
    AvemovBaseModule,
    DynamicFormModule,
    DynamicEntityModule
  ],
  providers: [
    APP_PROVIDERS,
    AUTH_HTTP_PROVIDER
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/app.module.ts